import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const degenerativeDisease: AnswerPathTreeNode = {
  path: 'degenerativeDisease',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredDegenerativeDiseaseDetails }],
};
